import { connect } from 'react-redux';
import View from './ExplanationsView';
import MobileView from '../../MobileFinancialPlan/MobileExplanations/MobileExplanationsView';
import MobileExplanationsWithMenuView from '../../MobileFinancialPlan/MobileExplanations/MobileExplanationsWithMenuView';
import { updateGoalViewState } from '../FinancialPlanActions';
import { goalId as selectedGoalIdSelector } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  recommendationTitleOrDefaultSelector,
  selectedSectionOrDefaultSelector,
  sectionsOrDefaultSelector,
  noTabsSelector,
  recommendationMessageOrDefaultSelector,
} from './ExplanationsSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalIdSelector(state, ownProps),
  selectedSection: ownProps.currentTab || selectedSectionOrDefaultSelector(state, ownProps),
  sections: sectionsOrDefaultSelector(state, ownProps),
  recommendationTitle: recommendationTitleOrDefaultSelector(state, ownProps),
  noTabs: noTabsSelector(state, ownProps),
  recommendationMessage: recommendationMessageOrDefaultSelector(state, ownProps),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setSelectedSection: (goalId, selectedSection, clientId) => () => {
    if (ownProps.setCurrentTab) {
      ownProps.setCurrentTab(selectedSection);
    } else {
      dispatch(
        updateGoalViewState(goalId, clientId, {
          selectedSection,
        }),
      );
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

export const MobileExplanations = connect(mapStateToProps, mapDispatchToProps)(MobileView);

export const MobileExplanationsWithMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileExplanationsWithMenuView);
